export default __webpack_public_path__ + "static/media/wildlife_tourism_icon.10cf0cc9.svg";